module TaskList {
    export var taskUpdateEventName: string = "frends.tasks.updated";

    export interface IImportResult {
        restoresDeletedPackage: boolean,
        namespacesAndClasses: INamespacesAndClasses
    }
    export interface INamespacesAndClasses
    {
        [namespace: string] : INamespaceAndClasses;
    }

    export interface INamespaceAndClasses {
        name: string;
        version: string;
        usedByProcesses: string[];
        namespace: string;
        classFunction: string;
    }

    export class TaskImportDialogController {
        public skipProcessTaskImport: boolean;
        public skipUpdateProcesses: boolean;
        public restoresDeletedPackage : boolean;
        public inProgress: boolean = false;
        public namespacesAndClasses : INamespacesAndClasses
        public hasTasks() {
            for (var namespace in this.namespacesAndClasses) {
                return true;
            }
            return false;
        }

        public taskHasSomeProcesses(namespaceAndClasses: any[]) {
           return _.some(namespaceAndClasses, x => x.usedByProcesses.length);
        }

        public close() {
            if (this.file) {
                this.file.value = "";
            }
            this.$modalInstance.dismiss();
        }

        public import() {
            var fd = new FormData();
            if (this.file) {
                var fileToUpload = this.file.files[0];
                console.log("importing " + fileToUpload.name);
                fd.append("file", this.file.files[0]);
            } else {
                fd.append("packageId", this.packageId);
                fd.append("packageVersion", this.packageVersion);
            }

            fd.append("skipProcessTaskImport", this.skipProcessTaskImport)
            fd.append("skipUpdateProcesses", this.skipUpdateProcesses)

            this.inProgress = true;
            this.$http.post<JsonResult>(this.taskImportUrl, fd,
                {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                }).then((result) => {
                    if (!result.data.success) {
                        this.notification.error(result.data.errorMessage);
                    } else {
                        this.notification.notify(result.data.data);
                        this.$rootscope.$broadcast(taskUpdateEventName);
                    }
                    
                })
                .finally(() => {
                    this.inProgress = false;
                    this.close();
                });
        }

        constructor(private taskImportUrl, importResult: IImportResult, public file, private packageId: string, private packageVersion: string, private $http: ng.IHttpService, private notification: INotifications, private $modalInstance: angular.ui.bootstrap.IModalServiceInstance, private $rootscope: ng.IRootScopeService) {
            this.namespacesAndClasses= importResult.namespacesAndClasses;
            this.restoresDeletedPackage= importResult.restoresDeletedPackage;
            this.skipProcessTaskImport = !this.hasTasks() && !importResult.restoresDeletedPackage;
        }
    }

    app.controller("taskImportDialogController", ["taskImportUrl", "namespacesAndClasses", "file", "packageId", "packageVersion", "$http", "notifications", "$uibModalInstance", "$rootScope", TaskImportDialogController]);
}